const SizesUtils = require('../../../viscomjs/utils/SizesUtils');
const mobileSizeLP = 426;
const mobileSize = 769;

let _W;
let _H;

function _update() {
    _W = SizesUtils.winWidth();
    _H = SizesUtils.winHeight();
}

_update();

module.exports = forceUpdate => {
    if (forceUpdate) _update();
    if (_W < mobileSize || _H < mobileSizeLP) {
        if (_W > _H) return 'static';
        return 'vertical';
    }
    return 'horizontal';
};



// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/utils/SizeMode.js